import { create } from 'zustand';
import type { UIState } from '../types';

interface UIStore extends UIState {
  setActiveView: (view: 'dashboard' | 'payment' | 'history' | 'error') => void;
  showModal: boolean;
  modalContent: string | null;
  openModal: (content: string) => void;
  closeModal: () => void;
  isOnline: boolean;
  setOnlineStatus: (status: boolean) => void;
}

export const useUIStore = create<UIStore>()((set) => ({
  activeView: 'dashboard',
  showModal: false,
  modalContent: null,
  isOnline: navigator.onLine,

  setActiveView: (view) => {
    set({ activeView: view });
  },

  openModal: (content) => {
    set({ showModal: true, modalContent: content });
  },

  closeModal: () => {
    set({ showModal: false, modalContent: null });
  },

  setOnlineStatus: (status) => {
    set({ isOnline: status });
  }
}));